export default __webpack_public_path__ + "static/media/mlb-logo.40daed7f.png";